export default "__VITE_ASSET__DuE9Ac0m__";